const idpKeys = {
  uat: "idp.uat.globallink.com",
  qa1: "idp.globallink.com",
  prod: "idp.globallink.com",
};

export const resolveGlSsoEnvironment = (configuredEnvironment, detectedEnvironment) => {
  const configured = configuredEnvironment?.trim();
  const value = configured || detectedEnvironment;
  if (value == null) {
    return null;
  }

  const environment = String(value).trim().toLowerCase();
  if (!Object.prototype.hasOwnProperty.call(idpKeys, environment)) {
    throw new Error("Unsupported GlobalLink environment");
  }
  return environment;
};

export const getGlSsoLoginUrl = (environment, configuredApiUrl) => {
  const resolved = resolveGlSsoEnvironment(environment, null);
  if (!resolved) {
    return null;
  }

  const apiUrl = resolved === "uat"
    ? configuredApiUrl?.trim()
    : resolved === "qa1"
      ? "https://api-staging.emalpha.com"
      : "https://api.emalpha.com";
  if (!apiUrl) {
    throw new Error("Missing GlobalLink API URL");
  }

  const url = new URL("/sso/saml2", apiUrl);
  url.searchParams.set("idp_key", idpKeys[resolved]);
  return url.toString();
};
